import React, {useState} from "react";
import "./CallScore.scss";
import "./sentiment.scss";
import {ReactComponent as CallScoreIcon} from "./CallScore.svg";
import FactorTitleAndScore from "./FactorTitleAndScore";
import {getClassNameByScore} from "./callScoreHelpers";

const ERROR_DATA_NOT_FOUND = {
    EXECUTIVE_SUMMARY: "Summary not found for the conversation.",
    SUMMARY: "Summary not found for the conversation.",
    NEXT_STEPS: "Next steps not found for the conversation.",
    CALL_OBJECTIONS: "Objections not found for the conversation.",
    CALL_QUESTIONS_AND_ANSWERS: "Questions and answers not found for the conversation.",
    CALL_SCORE: "Call score not available for the conversation."
}

const NA_SCORE = 'n/a';

const CallScore = ({callScore, factors, showColoredBackground, showCallSummary, hasCallScoreError }) => {
    const [activeFactorIndex, setActiveFactorIndex] = useState(null);

    const handleFactorClick= (index) => {
        if(index === activeFactorIndex) {
            setActiveFactorIndex(null);
        }else {
            setActiveFactorIndex(index)

        }
    }
    return <div className={`call-score ${showColoredBackground ? "no-padding no-background-color min-gap" : ""}`}>
        <div className={`total container ${showColoredBackground ? getClassNameByScore(callScore, 100) : ""}`}>
            {!showColoredBackground && <p className={"title"}>Call Score</p> }
            {
                hasCallScoreError ? <p className={"no-data-found"}>{ERROR_DATA_NOT_FOUND.CALL_SCORE}</p>
                    : <p className={`value ${getClassNameByScore(callScore, 100)}`}>
                        <CallScoreIcon className={getClassNameByScore(callScore, 100)}/>
                        <span>{callScore ? callScore.toString().toUpperCase() : NA_SCORE.toUpperCase()}</span>
                    </p>
            }
        </div>
        {
            !hasCallScoreError && <>
                {
                    factors?.map((factor, index) => (<FactorTitleAndScore key={`${index}-${factor.name}`}
                                                                          activeFactorIndex={activeFactorIndex}
                                                                          onFactorClick={handleFactorClick}
                                                                          title={factor.name}
                                                                          actual={factor.score}
                                                                          total={100}
                                                                          showGreyBackground={showColoredBackground}
                                                                          showCallSummary={showCallSummary}
                                                                          summary={factor.summary}
                                                                          index={index}
                                                                          factorsLength={factors.length}
                    />))
                }
            </>
        }
    </div>
}

export default CallScore;
